/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require("./registerServiceWorker");

require("./plugins");

import Vue from "vue";

import { sync } from "vuex-router-sync";
window.Vue = require("vue");
import store from "./store";

import router from "./router";

import api from "./api";
import api_gerencianet from "../../Modules/Gerencianet/Resources/assets/js/api_gerencianet";

import { Chart, registerables } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import VComp from "@vue/composition-api";

Chart.register(...registerables, zoomPlugin);
Vue.use(VComp);

Vue.config.devtools = process.env.NODE_ENV === "development";
Vue.config.productionTip = true;
Vue.config.debug = process.env.NODE_ENV === "development";
Vue.config.silent = process.env.NODE_ENV === "development";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

import moment from "moment";
import PortalVue from "portal-vue";
import VueChatScroll from "vue-chat-scroll";
import VueTheMask from "vue-the-mask";
import money from "v-money";
import VueSweetalert2 from "vue-sweetalert2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
Vue.use(DatePicker);

Vue.use(VueTheMask);
// register directive v-money and component <money>
Vue.use(money, {
    decimal: ",",
    thousands: ".",
    prefix: "R$ ",
    suffix: "",
    precision: 2,
    masked: false,
});

Vue.use(VueChatScroll);

require("./bootstrap");

import { BootstrapVue } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
Vue.use(VueFormWizard);

window.onload = function () {
    console.log("Loaded content");
};

moment.updateLocale("pt-br", {
    invalidDate: "Sem Data",
});

Vue.prototype.moment = moment;

Vue.use(PortalVue);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.use(BootstrapVue);
// Vue.component('load-page', require('./components/sistema/LoadPage.vue').default);
// Vue.component('orgao-component', require('./components/processos/Orgaos.vue').default);
// Vue.component('checklists', require('./components/checklist/Checklists.vue').default);
// Vue.component('tarefas', require('./components/tarefas/Tarefas.vue').default);

Vue.component("auth", require("./components/sistema/Auth.vue").default);
Vue.component("sidebar", require("./components/sistema/Sidebar.vue").default);
Vue.component(
    "alvaraForm",
    require("./components/alvaras/forms/AlvaraForm.vue").default
);
Vue.component(
    "profile-form",
    require("./components/account/profile.vue").default
);
Vue.component(
    "register-form",
    require("./components/users/forms/RegisterForm.vue").default
);

Vue.component(
    "modalRoute",
    require("./components/sistema/ModalRoute.vue").default
);
Vue.component("viewRota", require("./components/sistema/View.vue").default);
Vue.component("dropdown", require("./components/sistema/dropdown.vue").default);
Vue.component("modal", require("./components/sistema/Modal.vue").default);
Vue.component(
    "indicar",
    require("./components/indicacoes/forms/Indicar.vue").default
);
Vue.component(
    "dataTable",
    require("./components/sistema/DataTable.vue").default
);
Vue.component("eSelect", require("./components/sistema/eSelect.vue").default);
Vue.component("cliente", require("./components/sistema/Cliente.vue").default);
Vue.component("ligacao", require("./components/sistema/Ligacao.vue").default);
Vue.component(
    "historico",
    require("./components/sistema/Historico.vue").default
);
Vue.component("loading", require("./components/sistema/Loading.vue").default);
Vue.component(
    "notification",
    require("./components/notifications/Notification.vue").default
);
Vue.component(
    "WhatsApp",
    require("./components/notifications/WhatsApp.vue").default
);
Vue.component("anexos", require("./components/sistema/Anexos.vue").default);
Vue.component(
    "btnLoading",
    require("./components/sistema/BtnLoading.vue").default
);
Vue.component(
    "SubscritionButtonStatus",
    require("./components/subscription/SubscritionButtonStatus.vue").default
);

Vue.prototype.$api_gerencianet = api_gerencianet;
Vue.prototype.$api = api;
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

sync(store, router);

var app = new Vue({
    el: "#app",
    store,
    router,
});

window.app = app;
window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor;

export default { app, store };
